interface Props {
  icon: string;
  message: string;
  onDismiss: () => void;
}

export function Tooltip({ icon, message, onDismiss }: Props) {
  return (
    <>
      <div className="hs-tooltip-backdrop" onClick={onDismiss} />
      <div className="hs-tooltip">
        <span className="hs-tooltip-icon">{icon}</span>
        <p className="hs-tooltip-message">{message}</p>
        <button className="hs-tooltip-dismiss" onClick={onDismiss}>
          Got it!
        </button>
      </div>
    </>
  );
}
